(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .directive('webinar', webinar);

  /* ngInject */
  function webinar($sce, config, sessionService) {
    let directive = {
      link: link,
      restrict: 'E',
      templateUrl: '/templates/compliance_services/components/webinar.directive.html',
      scope: {
        config: '=',
        webinar: '='
      }
    };

    function link(scope, _element, _attrs) {
      scope.webinarVideoUrl = function(apiEndpoint, url) {
        return $sce.trustAsResourceUrl(`${apiEndpoint}${url}`);
      };

      scope.config = config;
      scope.sessionService = sessionService;
    }

    return directive;
  }
})();
